import { useState, useEffect } from "react";
import { Modal, Steps, Form, Input, Button, Select, Row, Col, Divider, Typography, Card, List, Tag, Avatar, Image, Flex, AutoComplete, message } from "antd";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import useToken from "antd/es/theme/useToken";
import { Link } from "react-router-dom";
import EmailTemplate from "./EmailTemplate";
import { uri } from "../backendUri";
import axiosApi from "../axiosApi/axiosApi";
import { setDate } from "date-fns";
// import Title from "antd/es/skeleton/Title";
const { Title, Text } = Typography;
const { Step } = Steps;
const statusOptions = ["auto-draft", "shipped", "pending", "processing", "on-hold", "completed", "cancelled", "refunded", "failed"];

const OrderEditModal = ({ orderToEdit, isOpen, onClose, save, saveLoading, products }) => {
  console.log(orderToEdit, 'ordrToEdit')
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const order = form.getFieldsValue(true);
  const [isEditReason, setIsEditReason] = useState(true);
  const showReasonForOnHold = order?.meta_data?.find((item) => item.key === "on_hold_reason") || orderToEdit?.meta_data?.find((item) => item.key === "on_hold_reason")
  const showReasonForRefund = order?.meta_data?.find((item) => item.key === "on_refund_reason") || orderToEdit?.meta_data?.find((item) => item.key === "on_refund_reason")

  const [reasonForHold, setReasonForHold] = useState('')
  const [reasonForRefund, setReasonForRefund] = useState('')
  const [statusForRefundNOnhold, setStatusForRefundNOnhold] = useState(orderToEdit?.status || order?.status || '')
  const [searchValue, setSearchValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditReportIdSearch, setIsEditReportIdSearch] = useState(true);
  const trackingId = orderToEdit?.meta_data?.find(meta => meta.key === "tracking_id");
  const [trakcing, setTracking] = useState(trackingId?.value || '');
  const [isDevice, setIsDevice] = useState(false)
  const [emailData, setEmailData] = useState({
    subject: '',
    heading: '',
    statusBasesText: ''
  })
  const [isEmailTemplateChanged, setIsEmailTemplateChanged] = useState(false);

  let foundImeie = orderToEdit?.meta_data.find(meta => meta?.key === "gr_imei");

  useEffect(() => {
    const productId = orderToEdit?.line_items?.[0]?.sku;
    if (!productId) return;

    const fetchProductCategory = async () => {
      try {
        const response = await axiosApi.get(`/fetchProductById/${productId}`);
        const product = response.data;

        const categories = product?.categories || [];
        const deviceCategory = categories.find(cat => cat.name === 'Devices');
        setIsDevice(!!deviceCategory);
      } catch (error) {
        console.error('Failed to fetch product or category:', error);
      }
    };

    fetchProductCategory();

  }, [orderToEdit?.line_items?.[0]?.sku]);

  useEffect(() => {
    if (trackingId?.value) {
      setTracking(trackingId?.value || '')
    }
  }, [trackingId])

  useEffect(() => {

    if (orderToEdit?.status == 'on-hold') {
      setReasonForHold(showReasonForOnHold?.value)
      setStatusForRefundNOnhold(orderToEdit?.status)
      showReasonForOnHold?.value && setIsEditReason(false)
    }
    
    if (orderToEdit?.status == 'refunded') {
      setReasonForRefund(showReasonForRefund?.value)
      setStatusForRefundNOnhold(orderToEdit?.status)
      console.log(showReasonForOnHold?.value);
      showReasonForRefund?.value && setIsEditReason(false)
    }


    return (() => {
      setStatusForRefundNOnhold('')
      //  setIsEditReason(true)
    })
  }, [showReasonForOnHold?.value, showReasonForRefund?.value, form, orderToEdit])


  const handleSearchReport = async (pastVal) => {
    setLoading(true);
    try {


      const { data } = await axiosApi.get(
        `${uri}/search-report-woocommerce?imei=${searchValue?.trim() || pastVal?.trim()}`
      );

      if (data.length) {
        const options = data.map((item) => ({ value: item.data.report?.reportid }));
        console.log(options, 'asdfads');

        message.success('Imei has been searched successfully')
        setOptions(options);
      } else {
        message.warning("No reports found for this IMEI."); // 🔴 Show warning if no results
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      message.error("Failed to fetch report. Please try again."); // 🔴 Show error notification
    } finally {
      setLoading(false);
    }
  };

  const statusColors = {
    "auto-draft": "gray",
    pending: "orange",
    processing: "blue",
    on_hold: "purple",
    completed: "green",
    cancelled: "red",
    refunded: "cyan",
    failed: "black",
  };
  useEffect(() => {
    if (orderToEdit) {

      form.setFieldsValue(orderToEdit);
    } else {
      form.resetFields();
    }
  }, [orderToEdit, form]);



  const steps = [
    { title: "Order Information", key: "orderInfo" },
    { title: "Customer & Shipping Details", key: "cust-ship-details" },
    { title: "Email Template", key: "email-template" },
    { title: "Review Order Details", key: "reviewOrd" },
  ];


  const handleSaveOrder = () => {
    form.validateFields()
      .then(() => {
        const allValues = form.getFieldsValue(true);
        let updatedMetaData = [];
        const trackingid = orderToEdit?.meta_data?.find(meta => meta.key === "tracking_id");
        const hasReportLink = orderToEdit?.meta_data?.find(meta => meta.key === "gr_report_link");
        const hasIMEI = orderToEdit?.meta_data?.find(meta => meta.key === "gr_imei");

        updatedMetaData = (searchValue || trakcing) && orderToEdit?.meta_data?.map(meta => {
          if (meta.key === "gr_report_link") {
            return { ...meta, value: `https://report.gearvu.io/report/${searchValue || foundImeie.value}` };
          }
          if (meta.key === "gr_imei") {
            return { ...meta, value: searchValue || foundImeie.value };
          }
          if (meta.key === "tracking_id") {
            return { ...meta, value: trakcing || trackingid.value };
          }
          return meta;
        });
        if (!hasReportLink?.value && foundImeie) {

          updatedMetaData?.push({
            key: "gr_report_link",
            value: `https://report.gearvu.io/report/${searchValue || foundImeie.value}`
          });
        }
        if (!hasIMEI && searchValue) {
          updatedMetaData?.push({
            key: "gr_imei",
            value: searchValue
          });
        }
        if (!trackingid && trakcing) {
          updatedMetaData?.push({
            key: "tracking_id",
            value: trakcing
          });
        }
        const resultForMetaData = updatedMetaData?.length ? updatedMetaData : order?.meta_data
        const updatedObjWithNoReason = { id: orderToEdit.id, billing: allValues?.billing, shipping: allValues?.shipping, status: allValues?.status, meta_data: [...resultForMetaData] }

        const curReasonVal = allValues?.status === 'on-hold' ? reasonForHold : reasonForRefund

        let reasons = allValues?.status === 'on-hold' ? { ...showReasonForRefund, key: 'on_hold_reason', value: curReasonVal } : { ...showReasonForRefund, key: 'on_refund_reason', value: curReasonVal };

        const updatedObj = { id: orderToEdit.id, billing: allValues?.billing, shipping: allValues?.shipping, meta_data: [...resultForMetaData.filter((item) => item.key !== reasons.key), reasons], status: allValues?.status }
        let finalValues = allValues?.status === 'on-hold' || allValues?.status === 'refunded' ? { ...updatedObj } : updatedObjWithNoReason
        setStatusForRefundNOnhold('')
        setSearchValue('')
        save({ orderPayload: { ...finalValues, productId: searchValue || foundImeie?.value }, emailData })
      })

      .catch((info) => console.log("Validation Failed:", info));
  };
  const handleEditClick = () => {
    if (isEditing) {
      form.submit();
    }
    setIsEditing(!isEditing);
  };

  const handleStepChange = (nextStep) => {
    if (isEmailTemplateChanged) {
      return message.warning('Please save template changes')

    }
    if (nextStep > currentStep) {
      // if (!searchValue && !foundImeie?.value && !options.length) {
      //   message.warning('Please attach report id');
      //   return;
      // } else {
      setCurrentStep(nextStep); // Move to the next step
      // }
    } else {
      setCurrentStep(nextStep);
    }
  };

  function handleTrackingInfo(e) {
    setTracking(e?.target?.value)
  }

  let styleObj = { display: 'flex', justifyContent: 'flex-end' }

  return (
    <Modal
      title={`Order Number #${orderToEdit?.number}`}
      open={isOpen}
      onCancel={() => {
        setStatusForRefundNOnhold('')
        onClose(false)
      }
      }
      footer={null}
      width={"60%"}
      style={{ marginTop: -80, height: '70%' }}
    >
      <Steps current={currentStep} onChange={handleStepChange}>
        {steps.map((step, index) => (
          <Step key={index} title={step.title} />
        ))}
      </Steps>

      <Form form={form} style={{ padding: 20, maxHeight: '700px' }} layout="vertical">
        {currentStep === 0 && (
          <>
            <Row gutter={[10, 10]} style={{ height: '30px' }}>
              <Col span={12} xs={12}>
                <Col>
                  <Typography.Text>Order Date:</Typography.Text> <Typography.Text>{orderToEdit?.date_created}</Typography.Text> <Tag color={statusColors[orderToEdit?.status]}>{orderToEdit?.status}</Tag>
                </Col>
              </Col>
              <Col span={12} xs={12} style={{ display: 'flex', width: '60%', flexDirection: "column", alignItems: 'flex-end' }}>
                <Form.Item style={{ width: '60%' }} name="status">
                  <Select onChange={(value) => {
                    setStatusForRefundNOnhold(value)
                    if (value === 'on-hold' && showReasonForOnHold?.value) {
                      setReasonForHold(showReasonForOnHold?.value)
                    }
                    if (value === 'refunded' && showReasonForRefund?.value) {
                      setReasonForRefund(showReasonForRefund?.value)
                    }
                  }} defaultValue={orderToEdit?.status} >
                    {statusOptions.map((status) => (
                      <Select.Option key={status} value={status}>
                        {status}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Divider />

            <Row style={{ overflowY: 'scroll', maxHeight: '300px' }} gutter={[16, 16]} >
              {orderToEdit?.line_items?.map((item) => (
                <Col key={item.id} span={24} xs={24} style={{ display: 'flex', justifyContent: 'space-between' }}>

                  <div style={{ width: 80, height: 100, marginRight: 16, borderRadius: 8, overflow: "hidden", }}>
                    <img src={item.image.src || './img-not.png'} alt="Product" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>

                  {/* Right: Product Details */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <div style={styleObj}>
                      <Typography.Text style={{ fontSize: 14 }}>{item.name}</Typography.Text>
                    </div>
                    <div style={styleObj}>
                      <Typography.Text> <Typography.Text strong>Quantity: </Typography.Text> {item.quantity}</Typography.Text>
                    </div>
                    <div style={styleObj}>

                      <Typography.Text> <Typography.Text strong>Subtotal: </Typography.Text>  ${item.subTotal}</Typography.Text>
                    </div>
                    <div style={styleObj} >
                      <Typography.Text> <Typography.Text strong>Sku: </Typography.Text> {item.sku || 'N/A'}</Typography.Text>
                    </div>
                    <div style={styleObj}>

                      <Typography.Text ><Typography.Text strong>Price:</Typography.Text>${item.price} </Typography.Text>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <Divider />

            <Row gutter={[32, 16]} style={{ maxHeight: '30%' }}>
              <Col xs={24} md={12}>
                <Typography.Title style={{ fontSize: 16 }} level={4}>Total Order Cost</Typography.Title>
                <div style={{ fontSize: 14, color: "#555" }}>
                  <Typography.Text strong>Toal:</Typography.Text>  <Typography.Text>${orderToEdit?.total}</Typography.Text> <br />
                  {/* <Typography.Text strong>Subtotal:</Typography.Text> <Typography.Text>${orderToEdit?.subtotal}</Typography.Text> <br /> */}
                  <Typography.Text strong>Shipping Cost:</Typography.Text> <Typography.Text>${orderToEdit?.shipping_total}</Typography.Text> <br />
                  <Typography.Text strong>Grand Total:</Typography.Text> <Typography.Text>${orderToEdit?.grandTotal}</Typography.Text> <br />
                  <Divider />
                  <Typography.Text strong>Payment Method:</Typography.Text> <Typography.Text>{orderToEdit?.payment_method}</Typography.Text> <br />
                  <Typography.Text strong>Payment Date & Time:</Typography.Text> <Typography.Text>{orderToEdit?.date_paid}</Typography.Text> <br />
                  <Typography.Text strong>Payment Status: </Typography.Text><Typography.Text>{orderToEdit?.needs_processing ? 'Paid' : 'Unpaid'}</Typography.Text>
                </div>
              </Col>
              <Col xs={24} md={12} sm={12}>
                <div >
                  <Typography.Title style={{ fontSize: 16 }} level={4}>Additional Details</Typography.Title>
                  <Typography.Text>{orderToEdit?.customer_note || "No additional notes provided."}</Typography.Text>
                </div>

                {(((statusForRefundNOnhold === 'refunded') || (statusForRefundNOnhold === 'on-hold'))) && (
                  <div style={{ marginTop: '65px' }}>
                    <Divider />
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                      <Button style={{ marginTop: -30, marginBottom: -30 }} type="text" icon={isEditReason ? <CheckOutlined /> : <EditOutlined />} onClick={() => setIsEditReason(!isEditReason)} />
                    </div>
                    <Typography.Title style={{ fontSize: 16 }} level={4}>{`${statusForRefundNOnhold || orderToEdit?.status} Reason`}</Typography.Title>
                    {

                      !isEditReason ? (
                        <Text style={{ fontSize: 16 }}>
                          {
                            (statusForRefundNOnhold === 'refunded' ? reasonForRefund : reasonForHold) ||
                            (order?.status === 'refunded' ? showReasonForRefund?.value : showReasonForOnHold?.value)
                          }
                        </Text>
                      ) : (
                        <>
                          {((orderToEdit?.status === 'on-hold' && statusForRefundNOnhold === 'on-hold') || statusForRefundNOnhold === 'on-hold') && (
                            <Input
                              style={{ height: '40px' }}
                              name="on-hold"
                              value={reasonForHold || ''}
                              onChange={(e) => setReasonForHold(e.target.value)}
                              placeholder="Enter reason for on hold"
                            />
                          )}

                          {((orderToEdit?.status === 'refunded' && statusForRefundNOnhold === 'refunded') || statusForRefundNOnhold === 'refunded') && (
                            <Input
                              style={{ height: '40px' }}
                              name="refunded"
                              value={reasonForRefund || ''}
                              onChange={(e) => setReasonForRefund(e.target.value)}
                              placeholder="Enter reason for refund"
                            />
                          )}
                        </>
                      )}
                  </div>
                )}

              </Col>
              <Col span={12} xs={24} md={12} sm={12} style={{ marginTop: 5 }}>
                {isEditReportIdSearch && options?.length ? (
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <a href={`https://dymax.a2hosted.com/report/${options[0]?.value}`} target="_blank" >View report</a>
                    <EditOutlined
                      style={{ cursor: "pointer", color: "#1677ff" }}
                      onClick={() => setIsEditReportIdSearch(false)} />
                  </div>
                ) : (
                  <>
                    {
                      isDevice ?
                        <>
                          <Flex justify="space-between">

                            <Typography.Text strong>Attach Device Report</Typography.Text>

                            <CloseOutlined
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() => setIsEditReportIdSearch(true)} />
                          </Flex>
                          <Form.Item
                            initialValue={foundImeie?.value || ""}
                            name="reportId"
                            rules={[{ required: true, message: "Report Id is required!" }]} // Added required validation
                          >
                            <AutoComplete
                              defaultValue={foundImeie?.value || ""}
                              options={options} // Shows search suggestions
                              onSearch={handleSearchReport} // Triggers when typing
                              value={searchValue}
                              onSelect={(value) => setSearchValue(value)} // Set selected value
                              style={{ width: "100%" }}
                            >
                              <Input.Search
                                placeholder="Enter report reportId"
                                loading={loading}
                                enterButton={
                                  <Button
                                    loading={loading}
                                    onClick={handleSearchReport}
                                    type="primary"
                                    style={{ background: "#1677ff", color: "white" }}
                                  >
                                    Search
                                  </Button>
                                }
                                onChange={(e) => setSearchValue(e.target.value)}
                                onPaste={(e) => {
                                  handleSearchReport(e.target.value);
                                  setLoading(true);
                                  e.preventDefault();
                                }}
                              />
                            </AutoComplete>
                          </Form.Item>
                        </> : null

                    }


                  </>
                )}
              </Col>
            </Row>


          </>
        )}
        {currentStep === 1 && (
          <Card
            title="Customer & Shipping Details"
            extra={
              <Button
                type="text"
                icon={isEditing ? <CheckOutlined /> : <EditOutlined />}
                onClick={handleEditClick}
              />
            }
            style={{ overflowY: 'scroll', maxHeight: '700px', borderRadius: 8, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
          >
            <Title level={4} style={{ marginBottom: 16 }}>
              Step 2: Customer & Shipping Details
            </Title>
            {isEditing &&
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                  <Typography.Title level={5}>Billing Details</Typography.Title>
                  {["first_name", "last_name", "address_1", "address_2", "email", "phone"].map((key) => (
                    <Form.Item key={key} label={key.replace("_", " ")} name={["billing", key]}>
                      <Input />
                    </Form.Item>
                  ))}
                </Col>

                <Col xs={24} sm={12}>
                  <Typography.Title level={5}>Shipping Details</Typography.Title>
                  {["first_name", "last_name", "address_1", "address_2", "email", "phone"].map((key) => (
                    <Form.Item key={key} label={key.replace("_", " ")} name={["shipping", key]}>
                      <Input />
                    </Form.Item>
                  ))}
                </Col>
              </Row>}
            {!isEditing && (
              <>
                <Row gutter={[32, 16]}>
                  {/* Left Side - Billing Details */}
                  <Col xs={24} md={12}>
                    <Typography level={5} style={{ marginBottom: 12, fontWeight: 'bold' }}>Billing Details</Typography>
                    <Typography.Text strong>Name: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.billing.first_name || order?.billing.first_name}
                      {orderToEdit?.billing.last_name || order?.billing.last_name}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Email: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.billing.email || order?.billing.email}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Phone: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.billing.phone || order?.billing.phone}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Address 1: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.billing.address_1 || order?.billing.address_1}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Address 2: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.billing.address_2 || order?.billing.address_2 || "N/A"}
                    </Typography.Text>
                  </Col>

                  {/* Right Side - Shipping Details */}
                  <Col xs={24} md={12}>
                    <Typography level={5} style={{ marginBottom: 12, fontWeight: 'bold' }}>Shipping Details</Typography>

                    <Typography.Text strong>Name: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.shipping.first_name || order?.shipping.first_name || "N/A"}
                      {orderToEdit?.shipping.last_name || order?.shipping.last_name || "N/A"}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Email: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.shipping.email || order?.shipping.email || "N/A"}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Phone: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.shipping.phone || order?.shipping.phone || "N/A"}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Address 1: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.shipping.address_1 || order?.shipping.address_1 || "N/A"}
                    </Typography.Text>
                    <br />

                    <Typography.Text strong>Address 2: </Typography.Text>
                    <Typography.Text>
                      {orderToEdit?.shipping.address_2 || order?.shipping.address_2 || "N/A"}
                    </Typography.Text>
                  </Col>
                </Row>

                <Divider />

                <Row>
                  <Col xs={24}>
                    <Typography.Text strong>Shipping Method: </Typography.Text> <Typography.Text>FedEx 2-Day Flat Rate</Typography.Text>
                  </Col>
                </Row>
                <Row>
                  <Col span={12} style={{ marginTop: 5 }}>
                    <Form.Item initialValue={trackingId?.value || ''} style={{ marginTop: 10 }} key={'tracking'} name="tracking">
                      <Typography.Text strong>Shipment Tracking Number:</Typography.Text>
                      <Input value={trakcing || ''} onChange={handleTrackingInfo} style={{ maxWidth: 400, marginTop: 10 }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>

                </Row>
              </>
            )}

          </Card>
        )}
        {currentStep === 2 && (
          <EmailTemplate orderData={orderToEdit} setEmailData={setEmailData} setIsEmailTemplateChanged={setIsEmailTemplateChanged} isEmailTemplateChanged={isEmailTemplateChanged} />
        )}
        {currentStep === 3 && (
          <Card title={`Order #${order?.number}`} style={{ overflowY: 'scroll', maxHeight: '700px', overflowY: "auto" }}>
            <Tag color={statusColors[order?.status] || "default"}>{order?.status.toUpperCase()}</Tag>
            {
              ((order.status === 'refunded' || order.status === 'on-hold')) ?
                <Text style={{ fontSize: 16 }}>{(order.status === 'refunded' ? reasonForRefund : reasonForHold) || (orderToEdit?.status == 'on-hold' ? showReasonForOnHold?.value : showReasonForRefund?.value)}</Text> :
                null

            }
            <Divider />
            <Row gutter={16}>
              <Col span={12}>
                <Title level={5}>Billing Information</Title>
                <Text>{order?.billing.first_name} {order?.billing.last_name}</Text><br />
                <Text>{order?.billing.address_1}, {order?.billing.city}, {order?.billing.country}</Text><br />
                <Text>Email: {order?.billing.email}</Text><br />
                <Text>Phone: {order?.billing.phone}</Text>
              </Col>
              <Col span={12}>
                <Title level={5}>Shipping Information</Title>
                <Text>{order?.shipping.first_name} {order?.shipping.last_name}</Text><br />
                <Text>{order?.shipping.address_1}, {order?.shipping.city}, {order?.shipping.country}</Text>
                <Text>Email: {order?.shipping.email}</Text><br />
                <Text>Phone: {order?.shipping.phone}</Text>
              </Col>
            </Row>
            <Divider />
            <Row gutter={16}>
              <Col span={12}>
                <Title level={5}>Order Details</Title>
                <Text>Subtotal: ${order?.total}</Text><br />
                <Text>Discount: ${order?.discount_total}</Text><br />
                <Text>Shipping: ${order?.shipping_total}</Text><br />
                <Text>Tax: ${order?.total_tax}</Text><br />
              </Col>
              <Col span={12}>
                <Title level={5}>Payment</Title>
                <Text>Method: {order?.payment_method_title}</Text><br />
              </Col>
            </Row>
            <Divider />
            <Title level={5}>Items</Title>
            <List
              itemLayout="horizontal"
              dataSource={order?.line_items}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={<Image style={{ height: 100, width: 80, borderRadius: 16, marginTop: '-14px' }} src={item.image.src || './img-not.png'} />}
                    title={item.name}
                    description={`Quantity: ${item.quantity} | Price: $${item.price}`}
                  />
                </List.Item>
              )}
            />
          </Card>
        )}


      </Form>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20 }}>
        <Button disabled={currentStep === 0} onClick={() => {
          setCurrentStep((prev) => prev - 1)
        }}>Previous</Button>
        {currentStep < steps.length - 1 ? (
          <Button onClick={() => {
            if (isEmailTemplateChanged) {
              return message.warning('Please save template changes')

            }
            // if (!searchValue && !foundImeie ) {
            // return message.warning('Please attach report id')

            // }else{
            setCurrentStep((prev) => prev + 1)
          }}
          // }
          >
            Next</Button>
        ) : (
          <Button loading={saveLoading} type="primary" style={{ background: "#1677ff", color: "white" }} onClick={handleSaveOrder}>Save Changes</Button>
        )}
      </div>
    </Modal>
  );
};

export default OrderEditModal;








